'use strict';

require('./DeviceService');
require('./KayleeService');
var Log = require('../../log/Log');
var log = Log.channel('ControllerService');
var moment = require('moment-timezone');
var semver = require('semver');
var sutl = require('../../sutl/Sutl');
require('./NetworkToolsService');
require('./RoomService');
require('./SharedPrefs');
require('./SleepService');

/* global AveoMemInfo */
/* global AveoPackageInfo */
/* global AveoStartActivity */
/* global AveoWatchdog */
/* global StatusBar */

angular.module('inara').factory('ControllerService', ControllerService);

var defaults = require('../../defaults/Defaults');

ControllerService.$inject = [
    '$interval',
    '$q',
    '$rootScope',
    '$state',
    '$timeout',
    'DeviceService',
    'KayleeService',
    'RoomService',
    'SharedPrefs',
    'SleepService',
    'NetworkToolsService',
    'LanguageService',
    'gettextCatalog',
];

function ControllerService(
    $interval,
    $q,
    $rootScope,
    $state,
    $timeout,
    DeviceService,
    KayleeService,
    RoomService,
    SharedPrefs,
    SleepService,
    NetworkToolsService,
    LanguageService,
    gettextCatalog
) {
    var appAutoUpdateEnabled = defaults.inara.appAutoUpdateEnabled;
    var appAutoUpdateTime = defaults.inara.appAutoUpdateTime;
    var appState = 'running';
    var appUpdateTimer = null;
    var batteryLevel = null;
    var controller = null;
    var deviceInitializationDone = false;
    var inaraInfo = null;
    var initialUpdateCheckDone = false;
    var isCharging = null;
    var kioskModeEnabled = defaults.inara.kioskModeEnabled;
    var language = null;
    var lastErrorTime = 0;
    var lastLogPushTime = 0;
    var logThrottleIndex = 0;
    var logThrottleTimer = null;
    var logThrottleTimesMs = [
        5 * 1000,
        10 * 1000,
        30 * 1000,
        60 * 1000,
        2 * 60 * 1000,
        5 * 60 * 1000,
        10 * 60 * 1000,
        30 * 60 * 1000,
        60 * 60 * 1000,
        2 * 60 * 60 * 1000,
        4 * 60 * 60 * 1000,
        8 * 60 * 60 * 1000,
        12 * 60 * 60 * 1000,
        24 * 60 * 60 * 1000,
    ];
    var onAir = null;
    var otaUpgradeEnabled = defaults.inara.otaUpgradeEnabled;
    var room = null;
    var showDriverConsoleLogs = false;
    var site = null;
    var sleepEnabled = defaults.inara.sleepEnabled;
    var sleepTimeout = defaults.inara.sleepTimeout;
    var timeZone = defaults.inara.timeZone;
    var updates = [];
    var startInfo = null;

    init();

    return {
        getUpdates: function () {
            // TODO; do we need to check the environment? I don't think this
            // should be called from the browser.
            return process.env.appEnv === 'browser' ? [] : updates;
        },
    };

    function init() {
        log.info('initializing');
        Log.onError(onLogError); // enable log push on error

        window.addEventListener('native.keyboardshow', function () {
            // Currently need to re-hide status bar when keyboard is shown.
            StatusBar.hide();
        });

        DeviceService.loaded().then(function () {
            KayleeService.setOfflineTimeoutMs(3000);
            RoomService.onStateChanged(onRoomServiceStateChanged);
        });

        $rootScope.$on('$stateChangeSuccess', onStateChange);
        $rootScope.$on('NetworkToolsResponse', onNetworkToolsResponse);
    }

    function checkForUpdate(updateKey, inaraChannel, forceUpdate, updateInfo, updatePromises) {
        var update = inaraInfo.updates[updateKey];
        var requiresUpdate = false;

        if (update.hasOwnProperty('channels') && !update.channels.hasOwnProperty(inaraChannel)) {
            return;
        }

        if (
            update.hasOwnProperty('deviceManagers') &&
            !update.deviceManagers.hasOwnProperty(DeviceService.getDeviceManagerName())
        ) {
            return;
        }

        if (update.hasOwnProperty('platforms')) {
            if (!update.platforms.hasOwnProperty('android')) return;

            if (
                typeof update.platforms.android === 'string' &&
                !semver.satisfies(controller.platformVersion, update.platforms.android)
            ) {
                return;
            }
        }

        if (update.hasOwnProperty('models') && !update.models.hasOwnProperty(controller.model))
            return;

        log.info('checking update for ' + update.name);

        if (
            update.type === 'knoxAnimations' ||
            update.type === 'file' ||
            update.type === 'sharedPrefs'
        ) {
            updatePromises.push(
                SharedPrefs.getInt(update.versionKey, 0)
                    .then(function (version) {
                        if (update.version > version) {
                            log.info(
                                'update required for ' +
                                    update.name +
                                    ' from version ' +
                                    version +
                                    ' to ' +
                                    update.version
                            );
                            updateInfo[updateKey] = angular.copy(update);
                            updateInfo[updateKey].fromVersion = version;
                            requiresUpdate = true;
                        } else {
                            log.info('no update required for ' + update.name);
                        }
                    })
                    .then($q.resolve, $q.resolve)
            );
        } else if (update.type === 'apk') {
            updatePromises.push(
                $q(function (resolve, reject) {
                    if (update.manifestUri) {
                        log.debug('getting manifest for ' + update.name);
                        var req = new XMLHttpRequest();
                        req.open('GET', update.manifestUri);
                        req.responseType = 'json';
                        req.timeout = 10000;
                        req.addEventListener('readystatechange', function (e) {
                            if (req.readyState === 4) {
                                if (req.response === null) {
                                    log.error(
                                        'failed getting manifest for ' +
                                            update.name +
                                            ', status = (' +
                                            req.status +
                                            ') "' +
                                            req.statusText +
                                            '"'
                                    );
                                } else {
                                    log.debug(
                                        update.name +
                                            ' got manifest = ' +
                                            JSON.stringify(req.response, null, 4)
                                    );
                                    Object.assign(update, req.response);
                                }

                                resolve();
                            }
                        });
                        req.send();
                    } else if (update.apkUri) {
                        log.debug(update.name + ' using direct apkUri = ' + update.apkUri);
                        resolve();
                    } else {
                        log.error('no apkUri or manifestUri found for ' + update.name);
                        resolve();
                    }
                })
                    .then(function () {
                        return $q(function (resolve, reject) {
                            if (!update.hasOwnProperty('versionCode')) {
                                log.error('no version information for ' + update.name + ' update');
                                resolve();
                                return;
                            }

                            AveoPackageInfo.getPackageInfo(
                                update.packageName,
                                function (pinfo) {
                                    var updateVersionIsEqual = update.versionNameOverridesCode
                                        ? semver.satisfies(
                                              update.versionName,
                                              '=' + semver.coerce(pinfo.versionName)
                                          )
                                        : pinfo.versionCode === update.versionCode;
                                    var updateVersionIsGreater = update.versionNameOverridesCode
                                        ? semver.satisfies(
                                              update.versionName,
                                              '>' + semver.coerce(pinfo.versionName)
                                          )
                                        : update.versionCode > pinfo.versionCode;

                                    if (
                                        updateVersionIsGreater ||
                                        (update.name === 'Inara' &&
                                            (forceUpdate || !updateVersionIsEqual))
                                    ) {
                                        log.info(
                                            'update required for ' +
                                                update.name +
                                                ' from version ' +
                                                pinfo.versionName +
                                                ' (' +
                                                pinfo.versionCode +
                                                ') to ' +
                                                update.versionName +
                                                ' (' +
                                                update.versionCode +
                                                ')'
                                        );
                                        updateInfo[updateKey] = angular.copy(update);
                                        updateInfo[updateKey].fromVersionName = pinfo.versionName;
                                        updateInfo[updateKey].fromVersionCode = pinfo.versionCode;
                                        requiresUpdate = true;
                                    } else {
                                        log.info('no update required for ' + update.name);
                                    }

                                    resolve();
                                },
                                function (err) {
                                    log.info(
                                        'update required to install ' +
                                            update.name +
                                            ' version ' +
                                            update.versionName +
                                            ' (' +
                                            update.versionCode +
                                            ')'
                                    );
                                    updateInfo[updateKey] = angular.copy(update);
                                    updateInfo[updateKey].fromVersionName = '<not installed>';
                                    updateInfo[updateKey].fromVersionCode = 0;
                                    requiresUpdate = true;
                                    resolve();
                                }
                            );
                        });
                    })
                    .then(function () {
                        if (
                            requiresUpdate ||
                            controller === null ||
                            !controller.settings.factoryInstallMode ||
                            !update.hasOwnProperty('deviceAdmin')
                        ) {
                            return;
                        }

                        return DeviceService.getDeviceAdminActiveForComponent(
                            update.deviceAdmin.packageName,
                            update.deviceAdmin.className
                        ).then(function (active) {
                            if (!active) {
                                log.info(
                                    'reinstalling ' + update.name + ' to activate device admin'
                                );
                                updateInfo[updateKey] = angular.copy(update);
                                updateInfo[updateKey].fromVersionName = update.versionName;
                                updateInfo[updateKey].fromVersionCode = update.versionCode;
                                requiresUpdate = true;
                            }
                        });
                    })
                    .then($q.resolve, $q.resolve)
            );
        } else if (update.type === 'uninstallApk') {
            updatePromises.push(
                $q(function (resolve, reject) {
                    AveoPackageInfo.getPackageInfo(
                        update.packageName,
                        function (pinfo) {
                            log.info('update required to uninstall ' + update.name);
                            updateInfo[updateKey] = angular.copy(update);
                            requiresUpdate = true;
                            resolve();
                        },
                        function (err) {
                            log.info('no update required to uninstall ' + update.name);
                            resolve();
                        }
                    );
                }).then($q.resolve, $q.resolve)
            );
        } else if (update.type === 'systemUpdate') {
            var systemUpdate = DeviceService.needsSystemUpdate(update);

            if (systemUpdate) {
                log.info(
                    'update required for ' +
                        update.name +
                        ' from ' +
                        systemUpdate.fromVersion +
                        ' to ' +
                        systemUpdate.toVersion
                );
                updateInfo[updateKey] = angular.copy(update);
                requiresUpdate = true;
            } else {
                log.info('no update required for ' + update.name);
            }
        } else {
            log.error('unrecognized update type for ' + JSON.stringify(update, null, 4));
        }
    }

    function formatThrottleTime(timeMs) {
        if (typeof timeMs === 'undefined') {
            timeMs = logThrottleTimesMs[logThrottleIndex];
        }

        var timeSec = timeMs / 1000;

        if (timeSec < 60) {
            return timeSec + ' seconds';
        } else if (timeSec === 60) {
            return '1 minute';
        } else if (timeSec < 60 * 60) {
            return timeSec / 60 + ' minutes';
        } else if (timeSec === 60 * 60) {
            return '1 hour';
        } else if (timeSec < 24 * 60 * 60) {
            return timeSec / 60 / 60 + ' hours';
        } else if (timeSec === 24 * 60 * 60) {
            return '1 day';
        } else {
            return timeSec / 24 / 60 / 60 + ' days';
        }
    }

    function getInaraChannel() {
        if (controller === null || !controller.$isLoaded()) {
            log.debug('getInaraChannel: controller not loaded yet');
            return null;
        }

        if (controller.$isPaired()) {
            if (site === null || !site.$isLoaded()) {
                log.debug('getInaraChannel: site not loaded yet');
                return null;
            } else {
                return site.settings.inaraChannel;
            }
        } else {
            return defaults.inara.channel;
        }
    }

    function goToUpdateState() {
        if (!$state.is('update')) {
            $state.go('update');
        } else {
            log.warning('already in update state, not transitioning again');
        }
    }

    function onAppUpdateTimeout() {
        log.info('time to perform auto app update');
        appUpdateTimer = null;
        updateAppIfNecessary();
        scheduleAppUpdate();
    }

    function onBatteryStatus(info) {
        batteryLevel = info.level;
        isCharging = info.isPlugged;

        log.info('onBatteryStatus: level = ' + batteryLevel + ', isPlugged = ' + isCharging);

        if (controller !== null) {
            controller.isCharging = isCharging;
            controller.batteryLevel = batteryLevel;
            controller.$save(false);
        }
    }

    function onControllerChanged(controller) {
        var needToSave = false;
        var networkToolsRequests = null;
        if (!controller.dbConnected) {
            log.debug('controller = ' + JSON.stringify(controller.$copyDatabaseProperties({})));
            log.warning(
                'detected database disconnect at ' +
                    moment(controller.dbConnectedTimestamp)
                        .tz('America/New_York')
                        .format('YYYYMMDD HH:mm:ss z') +
                    ', setting back to true'
            );

            controller.dbConnected = true;
            controller.dbConnectedTimestamp = Date.now();
            needToSave = true;
            setupOnDisconnect();
        }

        if (
            controller.hasOwnProperty('requests') &&
            controller.requests.hasOwnProperty('logs') &&
            controller.requests.logs !== null
        ) {
            log.info('sending logs due to pull request (' + controller.requests.logs + ')');
            controller.$pushLogs('pull', Log.getBuffer());
            controller.requests.logs = null;
            needToSave = true;
        }

        if (
            controller.hasOwnProperty('requests') &&
            controller.requests.hasOwnProperty('appUpdate') &&
            controller.requests.appUpdate !== null
        ) {
            log.info('updating app due to external request (' + controller.requests.appUpdate + ')');
            updateAppIfNecessary(true);
            controller.requests.appUpdate = null;
            needToSave = true;
        }

        if (
            controller.hasOwnProperty('requests') &&
            controller.requests.hasOwnProperty('ping') &&
            controller.requests.ping !== null
        ) {
            log.info('received ping request, deleting (' + controller.requests.ping + ')');
            controller.requests.ping = null;
            needToSave = true;
        }

        if (
            controller.hasOwnProperty('requests') &&
            controller.requests.hasOwnProperty('networkTools') &&
            controller.requests.networkTools !== null
        ) {
            // Retain the network tools requests until after controller saves
            // so any possible errors in the network tools don't fill up the
            // request queue
            networkToolsRequests = angular.copy(controller.requests.networkTools);
            delete controller.requests.networkTools;
            needToSave = true;
        }

        if (
            controller.hasOwnProperty('requests') &&
            controller.requests.hasOwnProperty('restartDevice') &&
            controller.requests.restartDevice !== null
        ) {
            log.info('received restartDevice request, restarting... (' + controller.requests.restartDevice + ')');
            controller.requests.restartDevice = null;
            needToSave = true;

            if (DeviceService.getCaps().hasRestartDevice) {
                DeviceService.restartDevice(2000);
            } else {
                log.warning('restartDevice not supported on this platform');
            }
        }

        if (
            controller.hasOwnProperty('requests') &&
            controller.requests.hasOwnProperty('restartInara') &&
            controller.requests.restartInara !== null
        ) {
            log.info('received restartInara request, restarting... (' + controller.requests.restartInara + ')');
            controller.requests.restartInara = null;
            needToSave = true;

            if (DeviceService.getCaps().hasRestartInara) {
                DeviceService.restartInara(3000);
            } else {
                log.warning('restartInara not supported on this platform');
            }
        }

        if (
            controller.hasOwnProperty('requests') &&
            controller.requests.hasOwnProperty('startActivity') &&
            controller.requests.startActivity !== null
        ) {
            AveoStartActivity.startActivity({
                action: 'ACTION_MAIN',
                className: controller.requests.startActivity.className,
                packageName: controller.requests.startActivity.packageName,
                flags: controller.requests.startActivity.flags,
            });
            controller.requests.startActivity.className = null;
            controller.requests.startActivity.packageName = null;
            controller.requests.startActivity.flags = null;
            needToSave = true;
        }

        if (controller.language !== language) {
            log.info('Controller language changed to: ' + controller.language);
            language = controller.language;
            LanguageService.setLanguage(controller.language);
        }

        if (controller.settings.appAutoUpdateEnabled !== appAutoUpdateEnabled) {
            log.info('autoUpdateEnabled changed in controller settings');
            appAutoUpdateEnabled = controller.settings.appAutoUpdateEnabled;
        }

        if (controller.settings.kioskModeEnabled !== kioskModeEnabled) {
            kioskModeEnabled = controller.settings.kioskModeEnabled;
            DeviceService.setKioskMode(kioskModeEnabled);
        }

        if (
            DeviceService.getCaps().hasAllowOtaUpgrade &&
            controller.settings.otaUpgradeEnabled !== otaUpgradeEnabled
        ) {
            otaUpgradeEnabled = controller.settings.otaUpgradeEnabled;
            DeviceService.setAllowOtaUpgrade(otaUpgradeEnabled);
        }

        var newShowDriverConsoleLogs = sutl.getNode(
            controller.settings,
            ['showConsoleLogs', 'driver'],
            false
        );

        if (newShowDriverConsoleLogs !== showDriverConsoleLogs) {
            showDriverConsoleLogs = newShowDriverConsoleLogs;
            Log.hideBuffer('driver', !showDriverConsoleLogs);
        }
        if (needToSave) {
            controller
                .$save(false)
                .catch(function (err) {
                    log.error('failed saving controller info: ' + err);
                    log.debug(
                        'controller data = ' +
                            JSON.stringify(controller.$copyDatabaseProperties({}))
                    );
                    log.debug(
                        'isAuthenticatedAsController = ' + KayleeService.isAuthenticatedAsController
                    );
                })
                .then(function () {
                    if (networkToolsRequests !== null) {
                        NetworkToolsService.handleControllerRequests(networkToolsRequests);
                    }
                })
                .catch(function (err) {
                    log.error('failed handling network tools request: ' + err);
                });
        }
    }

    function onLogError() {
        var now = Date.now();

        if (now - lastLogPushTime > logThrottleTimesMs[logThrottleIndex]) {
            lastLogPushTime = now;
            $timeout(onLogErrorTimeout, 5000);

            if (logThrottleIndex < logThrottleTimesMs.length - 1) {
                logThrottleIndex++;
                log.debug('increased log throttle time to ' + formatThrottleTime());
            }
        }

        lastErrorTime = now;

        if (logThrottleTimer !== null) {
            $timeout.cancel(logThrottleTimer);
        }

        if (logThrottleIndex > 0) {
            logThrottleTimer = $timeout(onLogThrottleTimeout, logThrottleTimesMs[logThrottleIndex]);
        }
    }

    function onLogErrorTimeout() {
        if (controller === null) {
            log.warning(
                "tried pushing logs due to error, but can't " + "because controller isn't loaded"
            );
        } else if (!controller.settings.autoPushErrorLogs) {
            log.info('not pushing error logs; behavior is disabled');
        } else {
            // Clear log buffer when pushing logs because of an error. If more
            // errors come along in a short period of time, then we'll only push
            // the new log messages.

            log.info('pushing logs because of error');
            RoomService.getController().$pushLogs('error', Log.getBuffer());
            Log.clearBuffer();
        }
    }

    function onLogThrottleTimeout() {
        logThrottleTimer = null;
        if (logThrottleIndex <= 0) return;

        var now = Date.now();

        if (now - lastErrorTime > logThrottleTimesMs[logThrottleIndex]) {
            logThrottleIndex = 0;
            log.debug('reset log throttle time to ' + formatThrottleTime());
        }
    }

    function onNetworkInterfacesResult(networkInterfaces) {
        // Delete empty properties from the networkInterfaces object since
        // firebase doesn't save empty objects, which would cause our
        // comparison with the previous value to return true.

        var deleteProps = [];

        for (var prop in networkInterfaces) {
            if (!networkInterfaces.hasOwnProperty(prop)) continue;
            if (
                typeof networkInterfaces[prop] === 'object' &&
                Object.keys(networkInterfaces[prop]).length === 0
            ) {
                deleteProps.push(prop);
            }
        }

        for (var i = 0; i < deleteProps.length; i++) {
            delete networkInterfaces[deleteProps[i]];
        }

        // Write networkInterfaces to the controller if they are different.

        if (RoomService.isControllerLoaded()) {
            var controller = RoomService.getController();
            if (
                !controller.hasOwnProperty('networkInterfaces') ||
                !sutl.objEquals(networkInterfaces, controller.networkInterfaces)
            ) {
                log.info(
                    'updating controller with new network interface info:' +
                        JSON.stringify(networkInterfaces, null, 4)
                );
                controller.networkInterfaces = networkInterfaces;
                controller.$save(false);
            }
        }
    }

    function onNetworkToolsResponse(event, response) {
        log.debug('onNetworkToolsResponse: ' + JSON.stringify(response, null, 4));
        var controller = RoomService.getController();
        if (!controller.responses) {
            controller.responses = { networkTools: {} };
        } else if (!controller.responses.networkTools) {
            controller.responses.networkTools = {};
        }
        var key = KayleeService.getNewKey();
        controller.responses.networkTools[key] = response;
        controller.responses.networkTools[key].timestamp = Date.now();
        controller.$save(false);
    }

    function onPause() {
        log.info('onPause');
        appState = 'paused';

        if (controller !== null) {
            controller.appState = appState;
            controller.$save(false);
        }
    }

    function onResume() {
        log.info('onResume');
        appState = 'running';

        if (controller !== null) {
            controller.appState = appState;

            if (!controller.dbConnected) {
                controller.dbConnected = true;
                controller.dbConnectedTimestamp = Date.now();
            }

            controller.$save(false);
        }
    }

    function onRoomChanged(room) {
        if (onAir === room.states.onAir) return;

        onAir = room.states.onAir;

        if (onAir) {
            setSleepEnabled(false);
        } else {
            setSleepEnabled(sleepEnabled);
        }
    }

    function onRoomServiceStateChanged(state) {
        if (!deviceInitializationDone && RoomService.isDeviceLoaded()) {
            deviceInitializationDone = true;

            window.addEventListener('batteryStatus', onBatteryStatus);
            document.addEventListener('pause', onPause);
            document.addEventListener('resume', onResume);

            // jsj: todo: promise chain the DeviceService stuff?

            if (DeviceService.getCaps().hasKioskModeEnable) {
                DeviceService.setKioskMode(kioskModeEnabled);
            }

            if (DeviceService.getCaps().hasAllowOtaUpgrade) {
                DeviceService.setAllowOtaUpgrade(otaUpgradeEnabled);
            }

            StatusBar.hide();
            setSleepEnabled(sleepEnabled);
            setSleepTimeout(sleepTimeout);
            Log.hideBuffer('driver', !showDriverConsoleLogs);

            DeviceService.getNetworkInterfaces().then(function (networkInterfaces) {
                log.debug('network interfaces: ' + JSON.stringify(networkInterfaces, null, 4));
            });

            log.debug('starting network interface polling');
            $interval(function () {
                // start timer to poll network interfaces
                DeviceService.getNetworkInterfaces().then(onNetworkInterfacesResult);
            }, 5000);

            $interval(sendControllerLog, 1 * 60 * 60 * 1000);
        }

        if (state === 'authenticated' && KayleeService.isAuthenticatedAsController()) {
            initialUpdateCheckDone = false;
        }

        if (RoomService.isControllerLoaded() && controller === null) {
            controller = RoomService.getController();
            inaraInfo = KayleeService.getInaraInfo();

            appAutoUpdateEnabled = controller.settings.appAutoUpdateEnabled;

            if (controller.language !== language) {
                log.info(
                    'RoomService loaded controller and language changed to: ' + controller.language
                );
                language = controller.language;
                LanguageService.setLanguage(controller.language);
            }

            $q.resolve()
                .then(DeviceService.getPlatformInfo)
                .then(function (platformInfo) {
                    // If Inara loses its Firebase connection, controller will be null.
                    if (controller === null) return $q.reject('controller null');

                    controller.platformInfo = platformInfo;

                    return $q.all([
                        cordova.getAppVersion.getAppName(),
                        cordova.getAppVersion.getVersionNumber(),
                        cordova.getAppVersion.getVersionCode(),
                    ]);
                })
                .then(function (data) {
                    // If Inara loses its Firebase connection, the controller will
                    // be null. See SNTY-1266.
                    if (controller === null) return $q.reject('controller null');

                    var appName = data[0];
                    var appVersion = data[1];
                    var appVersionCode = data[2];

                    log.info('updating controller info');

                    controller.userAgent = navigator.userAgent;
                    controller.uuid = device.uuid;
                    controller.model = device.model;
                    controller.platform = device.platform;
                    controller.platformVersion = device.version;
                    controller.ipAddress = null;
                    controller.appName = appName;
                    controller.appState = appState;
                    controller.appVersion = appVersion;
                    controller.appVersionCode = appVersionCode;
                    controller.dbConnected = true;
                    controller.dbConnectedTimestamp = Date.now();

                    controller.caps = DeviceService.getCaps();

                    // Set this on the global window object so we can access it
                    // from the device drivers.

                    window.inaraVersion = appVersion;
                    window.inaraSerialNumber = DeviceService.getSerialNumber();

                    if (batteryLevel !== null) {
                        controller.batteryLevel = batteryLevel;
                    }

                    if (isCharging !== null) {
                        controller.isCharging = isCharging;
                    }

                    return controller.$save(false).catch(function (err) {
                        log.error('failed saving controller info: ' + err);
                        return $q.resolve();
                    });
                })
                .then(function () {
                    if (controller === null) return $q.reject('controller null');
                    setupOnDisconnect();
                })
                .then(function () {
                    if (controller === null) return $q.reject('controller null');
                    if (!initialUpdateCheckDone && getInaraChannel() !== null) {
                        initialUpdateCheckDone = true;
                        return updateAppIfNecessary();
                    }
                })
                .then(scheduleAppUpdate)
                .then(function () {
                    if (controller === null) return $q.reject('controller null');
                    RoomService.getController().$onChange(onControllerChanged);

                    if (startInfo === null) {
                        AveoWatchdog.getStartInfo().then(function (info) {
                            startInfo = info;
                            if (sutl.getNode(startInfo, ['reason']) === 'exception') {
                                log.info('previous crash detected, pushing log');
                                controller.$pushLogs('crash', [
                                    {
                                        time: Date.now(),
                                        level: 'error',
                                        channel: 'ControllerService',
                                        message:
                                            'restarted due to crash: ' +
                                            JSON.stringify(startInfo, null, 4),
                                    },
                                ]);
                            }
                        });
                    }
                })
                .catch(function (err) {
                    log.info('aborted controller initialization: ' + err);
                });
        } else if (!RoomService.isControllerLoaded()) {
            if (controller !== null) {
                controller.$offChange(onControllerChanged);
                controller = null;
            }

            if (inaraInfo !== null) {
                inaraInfo = null;
            }
        }

        if (RoomService.isRoomLoaded() && room === null) {
            room = RoomService.getRoom();
            site = KayleeService.getSite(room.siteId);
            onAir = null;
            room.$onChange(onRoomChanged);
            site.$onChange(onSiteChanged);

            if (!initialUpdateCheckDone && getInaraChannel() !== null) {
                initialUpdateCheckDone = true;
                return updateAppIfNecessary();
            }
        } else if (!RoomService.isRoomLoaded()) {
            if (room !== null) {
                room.$offChange(onRoomChanged);
                room = null;
            }

            if (site !== null) {
                site.$offChange(onSiteChanged);
                site = null;
            }
        }

        if (state === 'controllerUnpaired') {
            // Set default sleep mode settings.
            sleepEnabled = defaults.inara.sleepEnabled;
            sleepTimeout = defaults.inara.sleepTimeout;

            setSleepEnabled(sleepEnabled);
            setSleepTimeout(sleepTimeout);
        }
    }

    function onSiteChanged() {
        if (sleepEnabled !== site.settings.sleepEnabled) {
            sleepEnabled = site.settings.sleepEnabled;

            if (sleepEnabled && !room.states.onAir) {
                setSleepEnabled(sleepEnabled);
            } else if (!sleepEnabled) {
                setSleepEnabled(sleepEnabled);
            }
        }

        if (sleepTimeout !== site.settings.sleepTimeout) {
            sleepTimeout = site.settings.sleepTimeout;
            setSleepTimeout(sleepTimeout);
        }

        var needToScheduleAppUpdate = false;

        if (timeZone !== site.settings.timeZone) {
            log.info('timeZone changed from ' + timeZone + ' to ' + site.settings.timeZone);
            timeZone = site.settings.timeZone;
            needToScheduleAppUpdate = true;
        }

        if (appAutoUpdateTime !== site.settings.appAutoUpdateTime) {
            log.info(
                'appAutoUpdateTime changed from ' +
                    appAutoUpdateTime +
                    ' to ' +
                    site.settings.appAutoUpdateTime
            );
            appAutoUpdateTime = site.settings.appAutoUpdateTime;
            needToScheduleAppUpdate = true;
        }

        if (needToScheduleAppUpdate) {
            scheduleAppUpdate();
        }
    }

    function onStateChange(event, toState, toParams, fromState, fromParams) {
        if (controller !== null) {
            controller.isInSetup = $state.includes('setup.**') && !$state.is('setup.summary');
            controller.$save(false);
        }
    }

    function scheduleAppUpdate() {
        if (appUpdateTimer !== null) {
            $timeout.cancel(appUpdateTimer);
            appUpdateTimer = null;
        }

        var timeRegex = /(\d+):(\d+)/;
        var timeMatch = timeRegex.exec(appAutoUpdateTime);

        if (timeMatch !== null) {
            var now = moment(Date.now());
            var updateMoment = moment(now)
                .tz(timeZone)
                .subtract(1, 'seconds')
                .minutes(timeMatch[2])
                .hours(timeMatch[1]);

            if (updateMoment.isBefore(now)) {
                updateMoment.add(1, 'days');
            }

            log.info(
                'scheduling app update for ' +
                    updateMoment.tz(timeZone).format('YYYY-MMM-DD h:mm a z')
            );

            var timeoutMs = updateMoment.valueOf() - now.valueOf();
            appUpdateTimer = $timeout(onAppUpdateTimeout, timeoutMs);
        } else {
            log.error('invalid format for appAutoUpdateTime string, "' + appAutoUpdateTime + '"');
        }

        return $q.resolve();
    }

    function sendControllerLog() {
        if (controller === null || !controller.$isLoaded) {
            log.warning('sendControllerLog: controller not available');
            return;
        }

        if (!KayleeService.isWorkingOnline()) return;

        AveoMemInfo.getMemInfo().then(function (memInfo) {
            var log = Object.assign(
                {
                    jsHeapSizeLimit: window.performance.memory.jsHeapSizeLimit,
                    totalJsHeapSize: window.performance.memory.totalJSHeapSize,
                    usedJsHeapSize: window.performance.memory.usedJSHeapSize,
                },
                memInfo
            );

            controller.$sendControllerLog(log);
        });
    }

    function setSleepEnabled(value) {
        log.debug('setSleepEnabled: ' + value);
        SleepService.enable(value);
    }

    function setSleepTimeout(value) {
        var timeout = parseInt(value, 10);

        if (timeout < 1) {
            log.error('setSleepTimeout: ' + timeout + ' limited to ' + 1);
            timeout = 1;
        }

        log.debug('setSleepTimeout: ' + timeout);
        SleepService.setSleepTimeout(timeout * 60);
    }

    function setupOnDisconnect() {
        var controller = RoomService.getController();
        var disconnectRef = controller.$ref.root.child('controllerDisconnected/' + controller.$id);
        return disconnectRef
            .onDisconnect()
            .cancel()
            .then(function () {
                disconnectRef.onDisconnect().set(KayleeService.serverValueTimestamp());
            });
    }

    function updateAppIfNecessary(forceUpdate) {
        if (!KayleeService.isWorkingOnline()) {
            log.info('working offline, app update skipped');
            return;
        }

        log.debug('checking for updates');
        if (typeof forceUpdate === 'undefined') forceUpdate = false;
        var inaraChannel = getInaraChannel();

        updates.length = 0;

        if (controller === null) {
            log.error("can't check for app updates because controller isn't loaded");
            return $q.resolve(false);
        }

        if (inaraChannel === null) {
            log.error("inaraChannel is null, can't check for app update");
            return $q.resolve(false);
        }

        log.info('using inara channel: ' + inaraChannel);

        if (inaraInfo === null) {
            log.error("inaraInfo is null, can't check for app update");
            return $q.resolve(false);
        }

        if (!inaraInfo.hasOwnProperty('updates')) {
            log.error('could not find updates collection in inaraInfo');
            return $q.resolve(false);
        }

        var updateInfo = {};
        var updatePromises = [];

        for (var updateKey in inaraInfo.updates) {
            if (!inaraInfo.updates.hasOwnProperty(updateKey)) continue;
            checkForUpdate(updateKey, inaraChannel, forceUpdate, updateInfo, updatePromises);
        }

        return $q.all(updatePromises).then(function () {
            var updateKeys = Object.keys(updateInfo).sort();

            for (var i = 0; i < updateKeys.length; i++) {
                updates.push(updateInfo[updateKeys[i]]);
            }

            if (updates.length > 0) {
                if (!appAutoUpdateEnabled && !forceUpdate) {
                    log.info('update required, but auto update disabled in controller settings');
                } else {
                    log.info('update required, going to update state');
                    goToUpdateState();
                    return true;
                }
            } else {
                log.info('no update required');
            }

            return false;
        });
    }
}

module.exports = ControllerService;
